import React, { Component } from 'react';
import { Segment, Header, List } from 'semantic-ui-react';

export default class RequiredTexts extends Component {
  render() {
    return (
      <Segment vertical>
        <Header as='h1' content="Required Texts" />
        <p>
          There are no required textbooks for this course. All assigned readings
          will be directly linked on the course schedule.
        </p>
      </Segment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/required-texts.js